import { render, staticRenderFns } from "./KosiwonList.vue?vue&type=template&id=386a023f"
import script from "./KosiwonList.vue?vue&type=script&lang=js"
export * from "./KosiwonList.vue?vue&type=script&lang=js"
import style0 from "./KosiwonList.vue?vue&type=style&index=0&id=386a023f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports